export const timeOffset = () => {
  const offset = new Date().getTimezoneOffset()
  return offset < 0
    ? "+" +
        `0${(-offset / 60) ^ 0}`.slice(-2) +
        ":" +
        ("0" + -offset % 60).slice(-2)
    : "-" +
        `0${(offset / 60) ^ 0}`.slice(-2) +
        ":" +
        ("0" + offset % 60).slice(-2)
}

export const getReferrer = () => {
  return document.referrer
}



// WEBPACK FOOTER //
// ./assets/common/tracking.js